import { CategoricalColumn } from 'baseui/data-table';
import { EMPTY_STRING } from 'commons/constants/immutable';

export const COL_NAMES = {
	segmentName: 'segmentName',
	dailyLimit: 'dailyLimit',
	overAllLimit: 'overAllLimit'
};

export const columnConfigs = [
	CategoricalColumn({
		title: 'Segment Name',
		mapDataToValue: (data: any) => {
			return data[COL_NAMES.segmentName] || EMPTY_STRING;
		},
		maxWidth: 450
	}),
	CategoricalColumn({
		title: 'Daily Limit(₹)',
		mapDataToValue: (data: any) => data[COL_NAMES.dailyLimit]?.toLocaleString('en-IN'),
		maxWidth: 200
	}),
	CategoricalColumn({
		title: 'Overall Limit(₹)',
		mapDataToValue: (data: any) => data[COL_NAMES.overAllLimit]?.toLocaleString('en-IN'),
		maxWidth: 200
	})
];

export const activeFilter = [
	{
		columnKey: 'Is Disabled',
		filterLabel: 'Active Coupons',
		filterValue: false
	}
];
